import { RoomId, roomId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomRecordingDeleteRequestDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomRecordingDeleteRequestDTO.validationSchema()
  );

  constructor(readonly data: RoomRecordingDeleteRequest) {
    JsonSchemaValidator.assert(RoomRecordingDeleteRequestDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId"],
      properties: {
        roomId
      }
    };
  }
}

interface RoomRecordingDeleteRequest {
  roomId: RoomId;
}
